// 2019-7-8 一类卡新增
export default function cardMaskFirst(no){
  return `华通银行储蓄卡(尾号${no.substring(no.length-4)})`
}



// WEBPACK FOOTER //
// ./src/modules/filter/bankCardMaskFirst.js